import {MouseEvent} from 'react';

/**
 * Calcaulates what offset across the target DOM element the mouse event occured at.
 * For example, a mouse event at x: 50 on a div of width 100, and a clientX of 10 would return 60;
 *
 * @param event The mouse event to check
 * @param domElement An optional element to check against. If not provided, will use the event taret
 * @returns The offset accross the DOM element the mouse event occured at
 */
export function getOffsetFromTarget(
  event: MouseEvent<HTMLElement> | globalThis.MouseEvent,
  domElement?: HTMLElement
): number {
  const element = domElement || (event.target as HTMLElement);

  const elementBoundingRect = element.getClientRects()[0];
  const elementLeftBound = elementBoundingRect?.x ?? 0;
  const eventX = event.clientX - elementLeftBound;

  return eventX;
}
